/**
 * User: Faris
 * Date: 6/24/13
 * Time: 4:30 PM
 */

define('app/views/preloader',['require'],function(require) {

  return Backbone.View.extend({

    view: 'preloader',

    update: function(percentage){
      TweenMax.to($('#Preloader', this.$el), 0.2, { width : (percentage * 100) + '%' });

      if(percentage >= 1){
        this.hide();
      }
    },

    show: function(){
      $('#Preloader', this.$el).width(0);
      TweenMax.to(this.$el, 0.3, { alpha: 1, display:'block', onComplete: this.afterShow });
    },

    hide: function(){
      TweenMax.to(this.$el, 0.3, { delay: 0.3, alpha: 0, display:'none', onComplete: this.afterHide });
    }

  });

});
